{
  "metadata": {
    "id": "gruvbox-light",
    "name": "Gruvbox",
    "description": "Портировано из темы «Gruvbox» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "gruvbox.json",
      "project": "morhetz",
      "url": "https://github.com/morhetz/gruvbox",
      "upstreamFile": "packages/ui/src/theme/themes/gruvbox.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.446,
      "paletteMaxS": 0.522,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 29.5,
      "syntaxVsTextMinDeltaE": 12.2,
      "chartsMinDeltaE": 24.4,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#076678",
      "hover": "#065c6c",
      "active": "#065462",
      "foreground": "#ffffff",
      "muted": "#07667880",
      "emphasis": "#076678"
    },
    "surface": {
      "background": "#fbf1c7",
      "foreground": "#332f2e",
      "muted": "#cdc5a5",
      "mutedForeground": "#46433a",
      "elevated": "#b7af94",
      "elevatedForeground": "#3c3836",
      "raised": "#9c9580",
      "raisedForeground": "#312e2c",
      "overlay": "#fbf1c733",
      "subtle": "#e4dbb6"
    },
    "interactive": {
      "border": "#948d7a",
      "borderHover": "#c6bd9e",
      "borderFocus": "#076678",
      "selection": "#3c383624",
      "selectionForeground": "#3c3836",
      "focus": "#07667859",
      "focusRing": "#07667847",
      "cursor": "#3c3836",
      "hover": "#3c383617",
      "active": "#3c383624"
    },
    "status": {
      "error": "#9d0006",
      "errorForeground": "#ffffff",
      "errorBackground": "#9d00061a",
      "errorBorder": "#9d000659",
      "warning": "#956110",
      "warningForeground": "#ffffff",
      "warningBackground": "#9561101a",
      "warningBorder": "#95611059",
      "success": "#74700d",
      "successForeground": "#ffffff",
      "successBackground": "#74700d1a",
      "successBorder": "#74700d59",
      "info": "#8f3f71",
      "infoForeground": "#ffffff",
      "infoBackground": "#8f3f711a",
      "infoBorder": "#8f3f7159"
    },
    "pr": {
      "open": "#74700d",
      "draft": "#555146",
      "blocked": "#956110",
      "merged": "#9d0006",
      "closed": "#9d0006"
    },
    "syntax": {
      "base": {
        "background": "#cdc5a5",
        "foreground": "#3c3836",
        "comment": "#5a5046",
        "keyword": "#9d0006",
        "string": "#023400",
        "number": "#7d3763",
        "function": "#065a6a",
        "variable": "#3c3836",
        "type": "#501009",
        "operator": "#0e0d0c"
      },
      "tokens": {
        "commentDoc": "#5a5046",
        "stringEscape": "#0e0d0c",
        "keywordImport": "#9d0006",
        "storageModifier": "#9d0006",
        "functionCall": "#065a6a",
        "method": "#065a6a",
        "variableProperty": "#065a6a",
        "variableOther": "#3c3836",
        "variableGlobal": "#7d3763",
        "variableLocal": "#0e0d0c",
        "parameter": "#3c3836",
        "constant": "#7d3763",
        "class": "#501009",
        "className": "#501009",
        "interface": "#501009",
        "struct": "#501009",
        "enum": "#501009",
        "typeParameter": "#501009",
        "namespace": "#501009",
        "module": "#9d0006",
        "tag": "#9d0006",
        "jsxTag": "#9d0006",
        "tagAttribute": "#065a6a",
        "tagAttributeValue": "#023400",
        "boolean": "#7d3763",
        "decorator": "#9d0006",
        "label": "#065a6a",
        "regexp": "#023400"
      }
    },
    "charts": {
      "series": [
        "#076678",
        "#8f3f71",
        "#74700d",
        "#956110",
        "#9d0006"
      ]
    },
    "chat": {
      "background": "#fbf1c7",
      "userMessage": "#3c3836",
      "userMessageBackground": "#b7af94",
      "assistantMessage": "#3c3836",
      "assistantMessageBackground": "#cdc5a5",
      "timestamp": "#555146",
      "divider": "#948d7a",
      "typing": "#555146"
    },
    "loading": {
      "spinner": "#076678",
      "spinnerTrack": "#cdc5a5",
      "skeleton": "#cdc5a5",
      "shimmer": "#c4bd9e"
    },
    "tools": {
      "background": "#cdc5a5",
      "border": "#948d7a",
      "headerHover": "#c6be9f",
      "icon": "#076678",
      "title": "#3c3836",
      "description": "#555146",
      "edit": {
        "added": "#74700d",
        "addedBackground": "#74700d1a",
        "removed": "#9d0006",
        "removedBackground": "#9d00061a",
        "modified": "#8f3f71",
        "modifiedBackground": "#8f3f711a",
        "lineNumber": "#555146"
      }
    },
    "markdown": {
      "heading1": "#3c3836",
      "heading2": "#3c3836",
      "heading3": "#3c3836",
      "heading4": "#3c3836",
      "link": "#076678",
      "linkHover": "#065c6c",
      "inlineCode": "#023400",
      "inlineCodeBackground": "#cdc5a5",
      "blockquote": "#555146",
      "blockquoteBorder": "#948d7a",
      "listMarker": "#076678bf",
      "bold": "#3c3836",
      "italic": "#3c3836e6",
      "strikethrough": "#555146",
      "hr": "#948d7a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393f",
        "foreground": "#ffffff",
        "contrast": 7.67
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c67756",
        "foreground": "#000000",
        "contrast": 6.17
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ad9045",
        "foreground": "#000000",
        "contrast": 6.85
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bcce63",
        "foreground": "#000000",
        "contrast": 12.15
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#678f41",
        "foreground": "#000000",
        "contrast": 5.58
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#62cb5f",
        "foreground": "#000000",
        "contrast": 10.23
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#67c288",
        "foreground": "#000000",
        "contrast": 9.65
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e78",
        "foreground": "#000000",
        "contrast": 5.38
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#60bdca",
        "foreground": "#000000",
        "contrast": 9.63
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3f798c",
        "foreground": "#ffffff",
        "contrast": 4.86
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b81bb",
        "foreground": "#000000",
        "contrast": 5.3
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#323786",
        "foreground": "#ffffff",
        "contrast": 10.36
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#7c53c1",
        "foreground": "#ffffff",
        "contrast": 5.43
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c659c4",
        "foreground": "#000000",
        "contrast": 5.63
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b7b",
        "foreground": "#ffffff",
        "contrast": 7.02
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c5567e",
        "foreground": "#000000",
        "contrast": 5.01
      }
    ]
  }
}
